import React, { Component } from 'react';
import Container from 'components/v2/container';
import List from './List';
export default class extends Component {
    render() {
        return (React.createElement(Container, { className: "py-8" },
            React.createElement(List, null)));
    }
}
